import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from 'core/fields/system/dependencies/components/dependencies-list';

export default class DependsOnField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.DEPENDS_ON;
    }

    static getValue(item) {
        return item.predecessors // new Vic apr 23 2024
        // return item.predecessors ? item.predecessors : []; - old
    }

    get sortHintMessage() {
        return 'Sort by depends on';
    }

    getCsvValue(item) {
        return _.map(DependsOnField.getValue(item).models, predecessor=>"#{0}".f(predecessor.shortId)).join(', ');
    }

    getValue(item) {return DependsOnField.getValue(item)}

    listItemSortFunctions(sort) {
        return {
            functions: [i => DependsOnField.getValue(i.item) || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }
}